import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { CMSSubcategoryRawData } from '@/Shared/AutoGenerated/Main'
import CMSArticle from '@/CMS/Content/Entity/CMSArticle'

export default class CMSSubcategory {
    constructor(
        public readonly title: string,
        public readonly description: string,
        public readonly slug: string,
        public readonly url: string,
        public readonly articles: CMSArticle[],
    ) {
        ensureNoUndefinedProperties(this)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: CMSSubcategoryRawData): CMSSubcategory {
        return new CMSSubcategory(
            entityData.title,
            entityData.description,
            entityData.slug,
            entityData.url,
            CMSArticle.hydrateMultiple(entityData.articles),
        )
    }

    static hydrateMultiple(
        entitiesData: CMSSubcategoryRawData[],
    ): CMSSubcategory[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
